import classNames from "classnames"
import React from "react"

import { Paragraph2 } from "@bounce/design-system"
import { isValidHttpURL } from "@bounce/util"

import { Link } from "../../Navigation/Link/Link"

export type TableProps = {
  data: string[][]
  className?: string
}

export const Table = ({ data, className }: TableProps) => {
  if (!data[0]) return null

  return (
    <div className={classNames("w-full overflow-x-auto", className)}>
      <table className="w-full text-left text-black">
        <thead className="text-white">
          <tr>
            {data[0].map((header, index) => (
              <th key={index} scope="col" className="sticky top-0 bg-primary-700 px-3 py-6 md:px-6">
                <Paragraph2 as="span" className="!font-bold">
                  {header}
                </Paragraph2>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.slice(1).map((row, rowIndex) => (
            <tr
              key={rowIndex}
              className={classNames(rowIndex % 2 === 0 ? "bg-white" : "bg-neutral-100", "border-b border-neutral-200")}>
              {row.map((item, itemIndex) => (
                <td key={itemIndex} className="px-3 py-4 md:px-6">
                  {isValidHttpURL(item) ? (
                    <Link href={item} rel="nofollow">
                      {item}
                    </Link>
                  ) : (
                    <Paragraph2 as="span">{item}</Paragraph2>
                  )}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
